import { ApiInstance } from '../..';
import { SearchQueryParams } from '../../../interface/paging';
import { TTenantRequest } from '../../../pages/tenants/type';
import { convert2QueryString } from '../../../utils/convert2QueryString';

export const getTenants = (params: SearchQueryParams | undefined) => {
    const requestURL = '/api/tenant?' + convert2QueryString(params);
    return ApiInstance.getInstance().get(requestURL);
};

export const getTenantDetail = (id: string | undefined | number) => {
    const baseUrl = `/api/tenant/${id}`;
    return ApiInstance.getInstance().get(baseUrl);
};

export const createTenant = (data: TTenantRequest) => {
    return ApiInstance.getInstance().post('/api/tenant', data);
};

export const updateTenant = (
    id: string | undefined | number,
    data: TTenantRequest
) => {
    const baseUrl = `/api/tenant/${id}`;
    return ApiInstance.getInstance().put(baseUrl, data);
};

export const deleteTenant = (id: string | undefined | number) => {
    const baseUrl = `/api/tenant/${id}`;
    return ApiInstance.getInstance().delete(baseUrl);
};
